import { FC } from 'react';

import { useI18nContext } from '../../hooks/contexts/i18n.context';
import { useModalContext } from '../../hooks/contexts/modal.context';
import * as Styles from './validate-membership.styles';

const ValidateMembership: FC = () => {
  const { translate } = useI18nContext();
  const { toggleModal } = useModalContext();

  return (
    <Styles.Body>
      <Styles.Text>
        {translate(['INFORMATION', 'CPF_MISMATCH_MESSAGE'])}
      </Styles.Text>
      <Styles.BtnContainer>
        <Styles.CutomBtn onClick={() => toggleModal({ open : false })}>
          {translate(['INFORMATION', 'UNDERSTOOD'])}
        </Styles.CutomBtn>
      </Styles.BtnContainer>
    </Styles.Body>
  );
};

export default ValidateMembership;
